import { useLastConnection } from '../hooks/use-last-connection';
import { useSsm5Connection } from '../hooks/use-ssm5-connection';
import { useVehicleDetails } from '../hooks/use-vehicle-details';
import { Ssm5ConnectionOffer } from './ssm5-connection-offer';

/**
 * The technician's most recent SSM5 connection, ready to reopen through the connect flow into a
 * new VIN session. A session still live is offered in its place and reopens its VIN session without
 * connecting again. Renders nothing without a connection or while its vehicle is unknown.
 *
 * @returns the section, or null when there is nothing to offer
 */
export function Ssm5LastConnection() {
    const { liveConnection } = useSsm5Connection();
    const lastConnection = useLastConnection();
    const vehicle = useVehicleDetails(liveConnection ? undefined : lastConnection?.vin);

    return <Ssm5ConnectionOffer live={liveConnection} recentConnection={lastConnection} vehicle={vehicle} />;
}
